import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

interface PhaseHorizonProps {
  activeNow: number | null;
}

/**
 * Narrow bar showing running workflow count.
 * Summary-only — no detailed endpoint exists for individual workflow pills.
 */
const PhaseHorizon: React.FC<PhaseHorizonProps> = ({ activeNow }) => {
  const { darkMode } = useTheme();

  // Loading state
  if (activeNow === null) {
    return (
      <div className={`h-8 rounded-md animate-pulse ${darkMode ? 'bg-gray-800' : 'bg-gray-100'}`} />
    );
  }

  // Active workflows
  if (activeNow > 0) {
    return (
      <div className={`flex items-center gap-2 px-3 py-1.5 rounded-md font-mono text-xs ${
        darkMode ? 'bg-gray-800/60 text-gray-300' : 'bg-gray-50 text-gray-600'
      }`}>
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" aria-label="Running" />
        </span>
        <span>
          <span className="font-bold text-emerald-400">{activeNow}</span>
          {' '}phase{activeNow > 1 ? 's' : ''} running
        </span>
      </div>
    );
  }

  // No active workflows
  return (
    <div className={`px-3 py-1.5 rounded-md font-mono text-xs ${
      darkMode ? 'text-gray-600' : 'text-gray-400'
    }`}>
      No active phases. Forge queue: ready.
    </div>
  );
};

export default PhaseHorizon;
